"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchConstants = void 0;
exports.MatchConstants = {
    MIN_ROUNDS_IN_HALF: 10,
    MAX_ROUNDS_IN_HALF: 15,
};
